import { Paper } from "@mui/material"
import { getPagedFilteredSavedAlbums, getPagedSavedAlbums, getSavedAlbumsLayout } from "../../reducers/albumListState";
import { useSelector } from "react-redux";
import AlbumListHeader from "./header/AlbumListHeader";
import AlbumListLoadingScreen from "../loading/AlbumListLoadingScreen";
import AlbumItem from "./AlbumItem";
import AlbumListFooter from "./footer/AlbumListFooter";
import { ALBUM_COVER_SIZE_NO_UNIT, ALBUM_DETAILS_WIDTH_NO_UNIT, ALBUM_GRID_COLUMN_GAP, ALBUM_GRID_ROW_GAP } from "../../utils/constants/viewConstants";
import { ALBUM_LAYOUTS } from "../../utils/constants/enumConstants";
import { savedAlbumsLoading } from "../../reducers/disablingProcesses";

const AlbumGrid = ({children, columnMinWidth}) => {
    const style = {
        gridTemplateColumns: `repeat(auto-fill, minmax(${columnMinWidth}rem, 1fr))`,
        rowGap: ALBUM_GRID_ROW_GAP,
        columnGap: ALBUM_GRID_COLUMN_GAP
    }

    return (
        <div className="d-grid px-0_5 jc-center" style={style}>
            {children}
        </div>
    )
}

const AlbumList = () => {
    const loadingAlbums = useSelector(savedAlbumsLoading);
    const albums = useSelector(loadingAlbums ? getPagedSavedAlbums : getPagedFilteredSavedAlbums);
    const layout = useSelector(getSavedAlbumsLayout);

    const columnMinWidth = layout === ALBUM_LAYOUTS.list ? ALBUM_COVER_SIZE_NO_UNIT + ALBUM_DETAILS_WIDTH_NO_UNIT : ALBUM_COVER_SIZE_NO_UNIT;

    return (
        <Paper className="full-height pt-1 bs-border-box d-flex flex-column gap-0_5">
            <AlbumListLoadingScreen />
            <AlbumListHeader />
            <div className="flex-1 overflow-y-scroll overflow-x-hidden py-0_25">
                <AlbumGrid columnMinWidth={columnMinWidth}>
                    {
                        albums && albums.map((album, index) => <AlbumItem key={index} album={album} layout={layout} />)
                    }
                </AlbumGrid>
            </div>
            <AlbumListFooter />
        </Paper>
    )
}

export default AlbumList;